export default __webpack_public_path__ + "static/media/about_us.eb1324f5.png";